import axios from "../../utils/axios";
import { BASE_API_URL } from "../../config/app";

// 查询模块信息
// export function queryModule(params) {
//   return axios({
//     url: BASE_API_URL + "/bo/api/v1/doc/module",
//     method: "get",
//     params: params
//   });
// }
// 查询模块信息
export function queryModule() {
  return axios({
    url: BASE_API_URL + "/bo/api/v1/common-area/list/res/city",
    method: "get"
  });
}
// 查询模块信息
export function queryScenicType() {
  return axios({
    url: BASE_API_URL + "/bo/api/v1/common-area/list/res/city",
    method: "get"
  });
}
// 查询模块 对应的 参数信息
export function queryRequest(params, data) {
  return axios({
    url: BASE_API_URL + "/bo/api/v1/common-area/list/res/city",
    method: "post",
    params: params,
    data: data
  });
}

// 查询景点列表
export function queryScenicList(params) {
  return axios({
    url: BASE_API_URL + "/bo/api/v1/destinations/page/res/spot",
    method: "get",
    params: params
  });
}
// 查询行程列表
export function queryTravelList(params) {
  return axios({
    url: BASE_API_URL + "/bo/api/v1/routes/page/all",
    method: "get",
    params: params
  });
}
//查询行程详情
export function queryTravelDetail(params) {
  return axios({
    url: BASE_API_URL + "/bo/api/v1/routes/detail/res/all?root&",
    method: "get",
    params: params
  });
}
//添加行程
export function insertRoute(params) {
  return axios({
    url: BASE_API_URL + "/bs/api/v1/travel",
    method: "post",
    data: params
  });
}
//根据目的地ID、距离查询住宿
export function queryHotel(params) {
  return axios({
    url: BASE_API_URL + "/bo/api/v1/merchant/page/res/hotels",
    method: "get",
    params: params
  });
}
//根据目的地ID、距离查询餐饮
export function queryFood(params) {
  return axios({
    url: BASE_API_URL + "/bo/api/v1/merchant/page/res/foods",
    method: "get",
    params: params
  });
}

//添加行程信息

// // 查询模块 对应的 参数信息
// export function queryRequest(params, data) {
//   return axios({
//     url: BASE_API_URL + "/bo/api/v1/doc/request",
//     method: "post",
//     params: params,
//     data: data
//   });
// }
